module.exports = __webpack_public_path__ + "img/yantai.a3c298e0.jpg";